import RedirectPaymentForm from "../shared/RedirectPaymentForm";
import kakaopayLogo from "../../../assets/payment-logos/kakaopay.png";

/**
 * Hosted-page KakaoPay (Checkout.com) tile.
 *
 * Pure redirect flow. KakaoPay is a customer-facing brand (unlike the
 * underlying Checkout.com processor), so we surface the official KakaoPay
 * badge at the top of the tile body.
 */
const CheckoutComKakaopayForm = (props) => (
  <RedirectPaymentForm
    {...props}
    paymentMethod="kakaopay"
    gateway="checkoutcom"
    brandLogoSrc={kakaopayLogo}
    brandLogoAlt="KakaoPay"
    requireEmail
  />
);

export default CheckoutComKakaopayForm;
